import React, { useState } from 'react';
import { Navbar, Container, Nav, Button } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/logo.jpg';

const Header = () => {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <Navbar
      bg="black"
      variant="dark"
      expand="lg"
      className="py-2 sticky-top"
      expanded={expanded}
      onToggle={setExpanded}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" className="fw-bold" onClick={() => setExpanded(false)}>
          <img
            src={logo}
            height="55"
            className="d-inline-block"
            alt="JLBB Ministries Logo"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-nav" />

        <Navbar.Collapse id="main-nav">
          <Nav className="ms-auto align-items-lg-center gap-2 py-2 py-lg-0">
            <Button
              as={Link}
              to="/events"
              variant={isActive('/event') ? 'warning' : 'outline-warning'}
              className="fw-bold"
              onClick={() => setExpanded(false)}
            >
              <i className="bi bi-calendar-event me-1"></i>Events
            </Button>
            <Button
              as={Link}
              to="/appointments"
              variant={isActive('/appointments') ? 'primary' : 'outline-primary'}
              className="fw-bold"
              onClick={() => setExpanded(false)}
            >
              <i className="bi bi-person-lines-fill me-1"></i>Appointments
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
